import { render, staticRenderFns } from "./StaleApplications.vue?vue&type=template&id=5a85af16&scoped=true"
import script from "./StaleApplications.vue?vue&type=script&lang=js"
export * from "./StaleApplications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a85af16",
  null
  
)

export default component.exports